import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { API_BASE_URL } from "./api-base";

export interface BookmarkItem {
  id: number;
  collection: string;
  note: string | null;
  problem: {
    id: number;
    title: string;
    levelNumber: number;
    difficulty: string;
    topic: string;
    acceptanceRate: number;
    status: string;
  } | null;
}

@Injectable({ providedIn: "root" })
export class BookmarkService {
  constructor(private readonly http: HttpClient) {}

  list() {
    return this.http.get<BookmarkItem[]>(`${API_BASE_URL}/bookmarks`);
  }

  add(problemId: number, collection = "My List", note?: string) {
    const payload: { problemId: number; collection: string; note?: string } = { problemId, collection };
    if (note !== undefined && note !== null) {
      payload.note = note;
    }
    return this.http.post<{ id: number; collection: string; note: string | null; problemId: number }>(
      `${API_BASE_URL}/bookmarks`,
      payload
    );
  }

  remove(bookmarkId: number) {
    return this.http.delete<{ success: boolean }>(`${API_BASE_URL}/bookmarks/${bookmarkId}`);
  }

  removeByProblem(problemId: number, collection?: string) {
    const q = collection ? `?collection=${encodeURIComponent(collection)}` : "";
    return this.http.delete<{ success: boolean }>(`${API_BASE_URL}/bookmarks/problem/${problemId}${q}`);
  }
}
